export const disableAllSwiperKeyboard = () => {
  const ALL_SWIPER = document.querySelectorAll('.swiper');
  ALL_SWIPER.forEach((o: any) => {
    const SWIPER = o.swiper;
    SWIPER?.keyboard?.disable();
  });
};

export const enableAllSwiperKeyboard = () => {
  const ALL_SWIPER = document.querySelectorAll('.swiper');
  ALL_SWIPER.forEach((o: any) => {
    const SWIPER = o.swiper;
    SWIPER?.keyboard?.enable();
  });
};
